export default __webpack_public_path__ + "bfe2de75fcb564f29f1e96d020e75027.png";